import React from 'react';
import { Slider } from '@fuxi/eevee-ui';
import classNames from 'classnames/bind';
import MyIcon from '@/components/MyIcon';
import styles from './index.module.css';

const cx = classNames.bind(styles);

const Volume = ({ volume, isSoundOff, handleSoundClick, handleSoundChange }) => {
  return (
    <>
      <div className={cx('sound-wrap')}>
        <MyIcon
          onClick={handleSoundClick}
          icon={isSoundOff ? 'sound-off' : 'sound'}
          size={20}
          className={cx('control-icon')}
        />
        <Slider
          className={cx('sound-slider', isSoundOff && 'sound-slider--off')}
          value={volume}
          onChange={handleSoundChange}
          disabled={false}
        />
        <span>{volume}</span>
      </div>
    </>
  );
};
export default React.memo(Volume);
